import React from "react";
import styles from "./Revenue.module.css";
import revenueStructure from "../../../assets/images/channel/revenue.png";
const Revenue = () => {
  return (
    <section className={styles.revenue}>
      <div className={styles.container}>
        <h2 data-aos="fade-up">Revenue Share Structure</h2>
        <div className={styles.content} data-aos="fade-up">
          <p>
            Buy STEM Kits with STEMx at standard kit cost and sell it for more
            profitable price with schools/parents.
          </p>
          <p className={styles.highlight}>
            100% of kits should be purchased from STEMx
          </p>
          <div className={styles.imageContainer}>
            {/* Placeholder for revenue structure image */}
            <div className={styles.imagePlaceholder}>
              <img src={revenueStructure} alt="revenueStructure" />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Revenue;
